import { default as Container } from './TopSellingProductsSection.container';
import { default as Component } from './TopSellingProductsSection';
export default Container(Component);
